// extracted by mini-css-extract-plugin
export default {"main":"_5642c928b2 _4dde4fe3e5","xmark":"c8b3b3ef6f","fl_img":"_5635e4b566 _0af4292731"};